/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AppRouteImport } from './routes/_app'
import { Route as AppIndexRouteImport } from './routes/_app/index'
import { Route as ProductGtinBatchUuidRouteImport } from './routes/product.$gtin.$batchUuid'
import { Route as AppTagProvisionRouteImport } from './routes/_app/tag.provision'
import { Route as AppBatchCreateRouteImport } from './routes/_app/batch.create'

const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRoute,
} as any)
const ProductGtinBatchUuidRoute = ProductGtinBatchUuidRouteImport.update({
  id: '/product/$gtin/$batchUuid',
  path: '/product/$gtin/$batchUuid',
  getParentRoute: () => rootRouteImport,
} as any)
const AppTagProvisionRoute = AppTagProvisionRouteImport.update({
  id: '/tag/provision',
  path: '/tag/provision',
  getParentRoute: () => AppRoute,
} as any)
const AppBatchCreateRoute = AppBatchCreateRouteImport.update({
  id: '/batch/create',
  path: '/batch/create',
  getParentRoute: () => AppRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof AppIndexRoute
  '/batch/create': typeof AppBatchCreateRoute
  '/tag/provision': typeof AppTagProvisionRoute
  '/product/$gtin/$batchUuid': typeof ProductGtinBatchUuidRoute
}
export interface FileRoutesByTo {
  '/': typeof AppIndexRoute
  '/batch/create': typeof AppBatchCreateRoute
  '/tag/provision': typeof AppTagProvisionRoute
  '/product/$gtin/$batchUuid': typeof ProductGtinBatchUuidRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_app': typeof AppRouteWithChildren
  '/_app/': typeof AppIndexRoute
  '/_app/batch/create': typeof AppBatchCreateRoute
  '/_app/tag/provision': typeof AppTagProvisionRoute
  '/product/$gtin/$batchUuid': typeof ProductGtinBatchUuidRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/batch/create'
    | '/tag/provision'
    | '/product/$gtin/$batchUuid'
  fileRoutesByTo: FileRoutesByTo
  to: '/' | '/batch/create' | '/tag/provision' | '/product/$gtin/$batchUuid'
  id:
    | '__root__'
    | '/_app'
    | '/_app/'
    | '/_app/batch/create'
    | '/_app/tag/provision'
    | '/product/$gtin/$batchUuid'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AppRoute: typeof AppRouteWithChildren
  ProductGtinBatchUuidRoute: typeof ProductGtinBatchUuidRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/': {
      id: '/_app/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/product/$gtin/$batchUuid': {
      id: '/product/$gtin/$batchUuid'
      path: '/product/$gtin/$batchUuid'
      fullPath: '/product/$gtin/$batchUuid'
      preLoaderRoute: typeof ProductGtinBatchUuidRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/tag/provision': {
      id: '/_app/tag/provision'
      path: '/tag/provision'
      fullPath: '/tag/provision'
      preLoaderRoute: typeof AppTagProvisionRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/batch/create': {
      id: '/_app/batch/create'
      path: '/batch/create'
      fullPath: '/batch/create'
      preLoaderRoute: typeof AppBatchCreateRouteImport
      parentRoute: typeof AppRoute
    }
  }
}

interface AppRouteChildren {
  AppIndexRoute: typeof AppIndexRoute
  AppBatchCreateRoute: typeof AppBatchCreateRoute
  AppTagProvisionRoute: typeof AppTagProvisionRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppIndexRoute: AppIndexRoute,
  AppBatchCreateRoute: AppBatchCreateRoute,
  AppTagProvisionRoute: AppTagProvisionRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AppRoute: AppRouteWithChildren,
  ProductGtinBatchUuidRoute: ProductGtinBatchUuidRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
